const config = {
  googleClientId:
    '1054067133797-v2j33428edplaelg0bj5et56mb3e1ou2.apps.googleusercontent.com',
  distributerId: '663b39b3ab4ec46c6ebcf259',
};

export const projects = {
  metaModel: {
    baseURL: 'https://api-phoenix.metamodels.ai/',
  },
  metaModelAdmin: {
    baseURL: 'https://api-phoenix.metamodels.ai/',
  },
  metaModelApp: {
    baseURL: 'https://api-phoenix.metamodels.ai/',
  },
  morphModels: {
    baseURL: 'https://api-phoenix.metamodels.ai/',
  },
};

export default config;
